import React from 'react'
import Skeleton from 'react-loading-skeleton'

import {CommonSlider} from '../../'

import styles from './styles.module.css'

const SliderSectionSkeleton = () => {
  return (
    <div className={styles.container}>
      <div
        style={{ marginBottom: 13 }}
        className="d-flex justify-content-between align-items-center"
      >
        <Skeleton width={33} height={20} />
      </div>
      <div className="d-flex">
        <CommonSlider
          className="slider-section"
          items={[
            <Skeleton style={{ marginLeft: 16 }} width={147} height={232} />,
            <Skeleton style={{ marginLeft: 16 }} width={147} height={232} />,
            <Skeleton style={{ marginLeft: 16 }} width={147} height={232} />,
          ]}
          sliderOptions={{
            autoWidth: true,
            autoPlay: false,
            gap: '16px',
          }}
        />
      </div>
    </div>
  )
}

export default SliderSectionSkeleton
